import script from "./RightTab.vue?vue&type=script&setup=true&lang=js"
export * from "./RightTab.vue?vue&type=script&setup=true&lang=js"

import "./RightTab.vue?vue&type=style&index=0&id=43f6b476&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f6b476"]])

export default __exports__